module.exports = __webpack_public_path__ + "img/chengguozh.e939b407.webp";